import {default as React} from "react";
import {Chip as MaterialChip} from "@material-ui/core";
import {ChipProps} from "@material-ui/core/Chip";

export function Chip(props: ChipProps) {
    return <MaterialChip clickable={props.clickable || !!props.onClick}
                         style={{ marginTop: 5, marginBottom: 5, marginRight: 9 }} {...props}/>
}
